import React from 'react';

import {
    yMapHintContainer, yMapHintDescription, yMapHintDescriptionLite, yMapHintInfo, yMapHintPreview
} from '@search/ymap/src/hint';
import { formatPrice } from '@search/helpers/src/formatPrice';
import { formatArea, formatAreaUnitFor } from '@search/helpers/src/formatArea';
import { formatFloor } from '@search/helpers/src/formatFloor';
import { Currency } from '@search/filter-enums/enums/Currency';

import { OfferYMapPlacemarkTooltip } from '../placemark/Placemark';
import { OfferYMapRoomPlacemarkProps } from './RoomPlacemarkProps';

export function OfferYMapRoomPlacemark({
    id,
    price,
    coordinates,
    totalArea,
    rent,
    floorsTotal,
    floor,
    preview,
    url,
    isActive,
    isVisited,
    isFavorite,
    onClick,
    targetBlank = true,
    isHighlighted,
    zIndexes,
    dataTest
}: OfferYMapRoomPlacemarkProps) {
    const areaPriceStr = ! rent && totalArea ?
        `${formatPrice({
            value: (price.rubPrice ?? price.value) / totalArea.value,
            currency: price.rubPrice ? Currency.RUB : price.currency,
            displayCurrency: true,
            noFractional: true
        })} за ${formatAreaUnitFor(totalArea)}` :
        undefined;

    const rentStr = rent?.untilitesIncluded ? 'КУ включены' : undefined;

    const hintLayout = yMapHintContainer(`
        ${preview ? yMapHintPreview(preview) : ''}
        ${yMapHintInfo(`
            ${yMapHintDescription(`
                ${totalArea ? formatArea(totalArea) : ''}
                ${(floor !== undefined ? `, ${formatFloor({ floor, floorsTotal })}` : '')}
            `)}
            ${yMapHintDescriptionLite(rentStr ?? areaPriceStr ?? '')}
        `)}
    `);

    const priceStr = formatPrice({
        value: price.rubPrice ?? price.value,
        currency: price.rubPrice ? Currency.RUB : price.currency,
        inWords: true
    });

    return (<OfferYMapPlacemarkTooltip
        id={id}
        url={url}
        isVisited={isVisited}
        isActive={isActive}
        onClick={onClick}
        title={priceStr}
        dataTest={dataTest}
        targetBlank={targetBlank}
        coordinates={{ y: coordinates.latitude, x: coordinates.longitude }}
        hintLayout={hintLayout}
        isHighlighted={isHighlighted}
        zIndexes={zIndexes}
        isFavorite={isFavorite}
    />);
}
